import { render, staticRenderFns } from "./ead-liberacoes.vue?vue&type=template&id=5151c7ff&scoped=true&"
import script from "./ead-liberacoes.vue?vue&type=script&lang=js&"
export * from "./ead-liberacoes.vue?vue&type=script&lang=js&"
import style0 from "./ead-liberacoes.vue?vue&type=style&index=0&id=5151c7ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151c7ff",
  null
  
)

export default component.exports